import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AuthenticatedApp } from './AuthenticatedApp';
import Loading from '../common/Loading';
import { useViewer } from '../../context/viewer-context';
import { GoogleAnalytics } from './google-analytics';
import WizardApp from './WizardApp';
import { useRouteMatch } from 'react-router';
import { SignInScreen } from '../sign-in/sign-in';
var publicRoutes = [
    '/content/:contentId',
    '/events/:eventId/content/:contentId',
];
export default function App() {
    var _a = useViewer(), viewer = _a.viewer, loading = _a.loading;
    var isPublicRoute = !!useRouteMatch(publicRoutes);
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(GoogleAnalytics, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    if (viewer && !viewer.categories.length) {
        return (_jsxs(_Fragment, { children: [_jsx(GoogleAnalytics, {}, void 0),
                _jsx(WizardApp, {}, void 0)] }, void 0));
    }
    if (viewer || isPublicRoute) {
        return (_jsxs(_Fragment, { children: [_jsx(GoogleAnalytics, {}, void 0),
                _jsx(AuthenticatedApp, {}, void 0)] }, void 0));
    }
    return (_jsxs(_Fragment, { children: [_jsx(GoogleAnalytics, {}, void 0),
            _jsx(SignInScreen, {}, void 0)] }, void 0));
}
//# sourceMappingURL=App.js.map